import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { MenuItem, MessageService, ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MultiSelect } from 'primeng/multiselect';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { OfficeControllerGetAll$Params } from 'src/app/api/fn/registry-offices/office-controller-get-all';
import { RegistryOfficeItem, RegistryItem, RegistryOfficeType } from 'src/app/api/models';
import { RegistryOfficesService, RegistryService, CountryService } from 'src/app/api/services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-warehouse-modal',
  templateUrl: './warehouse-modal.component.html',
  styleUrls: ['./warehouse-modal.component.scss'],
})
export class WarehouseModalComponent {
  @ViewChild('dt1') table?: Table;
  @ViewChild('keywordFilter') keywordFilter?: ElementRef<HTMLInputElement>;
  @ViewChild('typeFilter') typeFilter?: MultiSelect;

  protected readonly rowsPerPageOptions = [25, 50, 100, 200, 500];

  items: MenuItem[] | undefined;
  home: MenuItem | undefined;
  sites: RegistryOfficeItem[] = [];
  selectedWarehouseControl = new FormControl<RegistryOfficeItem | null>(null);
  registryDetail?: RegistryItem;
  advancedSearch = false;
  type: RegistryOfficeType[] = [];
  loading: boolean = false;
  totalRecords: number = 0;
  visibleModal: boolean = false;
  selectedMulti = new FormControl<number[]>([]);

  constructor(
    private officeService: RegistryOfficesService,
    public ref: DynamicDialogRef,
    public dialogService: DialogService,
    private title: Title,
    public config: DynamicDialogConfig
  ) {
    this.selectedWarehouseControl.setValue(config.data.selectedWarehouse);
  }

  ngOnInit() {
    this.items = [{ label: 'Magazzini' }, { label: 'Elenco magazzini' }];
    this.home = { icon: 'pi pi-home', routerLink: '/main/home' };

    this.getTypes();
    // this.selectedWarehouseControl.setValue(this.config.data!.selectedWarehouse);
  }

  getTypes() {
    this.officeService.officeControllerGetTypes().subscribe(res => {
      this.type = res.data.list;
    });
  }

  loadSites(event: TableLazyLoadEvent) {
    this.loading = true;
    const params: OfficeControllerGetAll$Params = {
      limit: +event.rows!,
      skip: +event.first!,
    };
    if (event.globalFilter != null) {
      // keyword
      if (event.globalFilter[0] != '') {
        params.query = event.globalFilter[0];
      }
      // role
      if (event.globalFilter[1] != undefined) {
        if (event.globalFilter[1]?.length > 0) {
          params.office_types = (event.globalFilter[1] as unknown as string[]).map(x => +x);
        }
      }
    }
    this.officeService.officeControllerGetAll(params).subscribe(res => {
      // Magazzino da non proporre (es. quello di partenza in un trasferimento)
      const excludedId = this.config.data?.excludeWarehouseId;
      const list = excludedId ? res.data.list.filter(s => s.id !== excludedId) : res.data.list;
      this.sites = list;
      this.totalRecords = res.data.count - (res.data.list.length - list.length);
      this.loading = false;
      const selected = this.config.data?.selectedWarehouse;
      if (selected) {
        const match = this.sites.find(s => s.id === selected.id);
        if (match) {
          this.selectedWarehouseControl.setValue(match);
        }
      }
    });
  }

  clear(table: Table) {
    table.clear();
    if (this.keywordFilter) {
      this.keywordFilter.nativeElement.value = '';
    }
    if (this.typeFilter) {
      this.selectedMulti.setValue([]);
      this.typeFilter.uncheckAll();
      this.typeFilter.updateLabel();
    }
  }

  close() {
    this.ref.close();
  }

  save() {
    this.ref.close({ value: this.selectedWarehouseControl.value });
  }
}
